import { createApp, ref, nextTick, App, Ref } from "vue";
import PrimeVue from "primevue/config";
import SazkaAlertComponent from "@/shared/components/molecules/SazkaAlert.vue";
import type { SazkaAlert } from "@/shared/model/sazka-alert";

export function sazkaAlert({
    title,
    subText,
    linkText,
    link,
    btnCloseText,
    errorCode,
    icon,
    iconColor,
    iconSize,
}: SazkaAlert) {
    const alertRef: Ref<App | null> = ref(null);
    const isVisible = ref(true);
    const root = document.createElement("div");

    nextTick(() => {
        const app = createApp(SazkaAlertComponent, {
            title,
            subText,
            linkText,
            link,
            btnCloseText,
            errorCode, //TODO: add icon if needed
        });

        app.use(PrimeVue);
        alertRef.value = app;

        alertRef.value.component("SazkaAlertComponent", {
            ...SazkaAlertComponent,
            emits: ["close"],
        });

        alertRef.value.mount(root);
    });

    return {
        isVisible,
    };
}
